import PropTypes from 'prop-types'

import Email from '../Email'
import { IconEnvelope } from '../Icon'

import styles from './DesktopContactEntry.module.scss'

const BubbleWithIcon = () => (
  <div className={styles.iconBubble}>
    <IconEnvelope />
  </div>
)

const propTypes = {
  value: PropTypes.string
}

const DesktopEmail = ({ value }) => (
  <div className={styles.container}>
    <Email className={styles.value} value={value} iconStart={BubbleWithIcon} />
  </div>
)

DesktopEmail.propTypes = propTypes

export default DesktopEmail
